<template>
  <div id="financeTop">
    <div class="title">
      <img src="../../assets/image/icon_caiw@2x.png" style="width:34px" alt />
      <h3>行政</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="clientActive" @tab-click="handleClick">
        <!-- 1邮寄 -->
        <el-tab-pane label="邮寄" name="1">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="报告/物品名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='1'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button @click="handleSearch1" class="search">查询</el-button>
              <el-button class="creat" style="background-color:#40A0F2;" @click="addMailClick">新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/mail_output','邮寄列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/物品名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:14%;text-align:center">提交时间</div>
                <div class="headerItem" style="width:18%;text-align:center">状态</div>
                <div class="headerItem" style="width:25%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in list"
                  @click="handleCheckMail(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p class="tableItemContent" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <!-- color:#FF3333 -->
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>
                  <div class="bodyItem" style="width:18%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckMail(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin1==0 ? false : true"
                        @click.stop="handleRemoveMail(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 2报告用章 -->
        <el-tab-pane label="报告用章" name="2">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='2'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button class="search" @click="handleSearch2">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectClearClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/report_output','报告用章列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">项目名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:14%;text-align:center">提交时间</div>
                <div class="headerItem" style="width:18%;text-align:center">状态</div>
                <div class="headerItem" style="width:25%;text-align:center">操作</div>
              </div>
              <ul v-if="list.length>0" class="table__body">
                <li
                  class="tableBodyItem"
                  style="height:9vh;padding:10px 40px;"
                  v-for="item in list"
                  @click="handleCheckReport(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>

                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>
                  <div class="bodyItem" style="width:18%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333;font-size:12px;"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255);font-size:12px;"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95);font-size:12px;"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10);font-size:12px;"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                      style="font-size:12px"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                    <p
                      v-if="item.top_content"
                      :title="item.top_content"
                      style="font-size:12px"
                      class="overflowDoit2row"
                    >{{item.top_content}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckReport(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin2==0 ? false : true"
                        @click.stop="handleRemoveSettlement(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 3其他用章 -->
        <el-tab-pane label="其他用章" name="3">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="报告/文件名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='3'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button @click="handleSearch3" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectZhuanClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/chapter_output','其他用章列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/文件名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:14%;text-align:center">提交时间</div>
                <div class="headerItem" style="width:15%;text-align:center">状态</div>
                <div class="headerItem" style="width:8%;text-align:center">是否存档</div>
                <div class="headerItem" style="width:20%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in list"
                  @click="handleCheckChapter(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>
                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckChapter(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin3==0 ? false : true"
                        @click.stop="handleRemoveExpert(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 4合同用章 -->
        <el-tab-pane label="合同用章" name="4">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left contractSearchRow" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="报告/文件名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='4'" @my-one-change="handleSearchPeopleChange"></one-selected>
              <el-select
                v-if="clientActive=='4'"
                v-model="searchIsArchive1"
                @change="handleSearchIsArchiveChange"
                clearable
                class="archiveSelect"
                placeholder="是否存档"
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="2"></el-option>
              </el-select>
            </div>
            <div class="right">
              <el-button @click="handleSearch4" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectHtClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/contract_seal_output','其他用章列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/文件名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:14%;text-align:center">提交时间</div>
                <div class="headerItem" style="width:15%;text-align:center">状态</div>
                <div class="headerItem" style="width:8%;text-align:center">是否存档</div>
                <div class="headerItem" style="width:20%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in list"
                  @click="handleCheckHt(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>
                  <div class="bodyItem" style="width:18%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>
                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:8%;padding-right:0;text-align:center;">
                    <p
                      v-if="item.is_archive_show=='是'"
                      style="text-align:center;color:rgb(48, 173, 95);"
                    >{{item.is_archive_show}}</p>
                    <p
                      v-else-if="item.is_archive_show=='否'"
                      style="text-align:center;color:#FF3333;"
                    >{{item.is_archive_show}}</p>
                    <p v-else style="text-align:center;">{{item.is_archive_show}}</p>
                  </div>
                  <div class="bodyItem" style="width:20%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckHt(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin4==0 ? false : true"
                        @click.stop="handleRemoveHt(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 5合同存档审批 -->
        <el-tab-pane label="合同存档" name="5">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="合同名称"></el-input>
              <!-- <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData1Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>-->
              <one-selected v-if="clientActive=='5'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button @click="handleSearch5" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectHtSaveClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/contract_archive_output','合同存档列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/文件名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:14%;text-align:center">提交时间</div>
                <div class="headerItem" style="width:18%;text-align:center">状态</div>
                <div class="headerItem" style="width:25%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in list"
                  @click="handleCheckHtSave(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>
                  <div class="bodyItem" style="width:18%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>
                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckHtSave(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin5==0 ? false : true"
                        @click.stop="handleRemoveHtSave(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 6外部用章 -->
        <el-tab-pane label="外部用章" name="6">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="报告/文件名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='6'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button @click="handleSearch6" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectExtrenalClick"
              >新增</el-button>
              <el-button
                class="creat"
                style="background-color:#67c23a;"
                @click="handleOutClick('/api/Doc/external_seal_output','外部用章列表')"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">报告/文件名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:14%;text-align:center">提交时间</div>
                <div class="headerItem" style="width:18%;text-align:center">状态</div>
                <div class="headerItem" style="width:25%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in list"
                  @click="handleCheckExtrenal(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.business_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>
                  <div class="bodyItem" style="width:18%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>
                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckExtrenal(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin6==0 ? false : true"
                        @click.stop="handleRemoveExtrenal(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 7公示存档 -->
        <el-tab-pane label="公示存档" name="7">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
            </div>
            <div class="right">
              <el-button @click="handleSearch7" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectAnnounceClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:30%">项目名称</div>
                <div class="headerItem" style="width:15%;text-align:center">登记人</div>
                <div class="headerItem" style="width:16%;text-align:center">提交时间</div>
                <div class="headerItem" style="width:15%;text-align:center">状态</div>
                <div class="headerItem" style="width:24%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in list"
                  @click="handleCheckAnnounce(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:30%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.announce_name || ''}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p style="text-align:center;" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:16%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>
                  <div class="bodyItem" style="width:15%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="text-align:center;color:#FF3333"
                      v-if="item.show_state=='草稿'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="text-align:center;color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="text-align:center;color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state || '-'}}</p>
                  </div>
                  <div class="bodyItem" style="width:24%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckAnnounce(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin7==0 ? false : true"
                        @click.stop="handleRemoveAnnounce(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 8告知书 -->
        <el-tab-pane label="告知书" name="8">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                @change="searchData1Change"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 4%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                @change="searchData2Change"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
            </div>
            <div class="right">
              <el-button @click="handleSearch8" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectNotifyClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:34%">项目名称</div>
                <div class="headerItem" style="width:14%;text-align:center">告知人</div>
                <div class="headerItem" style="width:18%;text-align:center">告知时间</div>
                <div class="headerItem" style="width:14%;text-align:center">状态</div>
                <div class="headerItem" style="width:20%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="list.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in list"
                  @click="handleCheckNotify(item.id)"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:34%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.notify_name || ''}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.notifier || '-'}}</p>
                  </div>
                  <div class="bodyItem" style="width:18%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.notify_time || item.show_time || '-'}}</p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="text-align:center;color:#FF3333"
                      v-if="item.show_state=='草稿'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="text-align:center;color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="text-align:center;color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state || '-'}}</p>
                  </div>
                  <div class="bodyItem" style="width:20%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click.stop="handleCheckNotify(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin8==0 ? false : true"
                        @click.stop="handleRemoveNotify(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="list.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 弹窗--报销 -->
    <!-- :class="showForm==='showFormAdd' || showForm==='showFormHandle'? 'addClientDia' : 'addOtherDia'" -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      key="finance"
      :before-close="handleClose"
      :class="'addFinanceDia'"
      @close="handleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span
          class="title-age"
          v-if="showForm==='showFormAdd'&& $store.state.process.admin.formData.is_draft!='1'"
        >新增邮寄</span>
        <span
          class="title-age"
          v-if="showForm==='showFormAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑邮寄</span>
        <span class="title-age" v-if="showForm==='showFormHandle'">邮寄详情</span>
        <span
          class="title-age"
          v-if="showForm==='showFormClearAdd' && $store.state.process.admin.formData.is_draft!='1' "
        >新增报告用章</span>
        <span
          class="title-age"
          v-if="showForm==='showFormClearAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑报告用章</span>
        <span class="title-age" v-if="showForm==='showFormClearHandle'">报告用章详情</span>
        <span
          class="title-age"
          v-if="showForm==='showFormZhuanAdd' && $store.state.process.admin.formData.is_draft!='1'"
        >新增其他用章</span>
        <span
          class="title-age"
          v-if="showForm==='showFormZhuanAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑其他用章</span>
        <span class="title-age" v-if="showForm==='showFormZhuanHandle'">其他用章详情</span>

        <span class="title-age" v-if="showForm==='showFormHtAdd' && addHtForm.is_draft!='1'">新增合同用章</span>
        <span class="title-age" v-if="showForm==='showFormHtAdd' && addHtForm.is_draft=='1'">编辑合同用章</span>
        <span class="title-age" v-if="showForm==='showFormHtHandle'">合同用章详情</span>

        <span
          class="title-age"
          v-if="showForm==='showFormHtSaveAdd' && $store.state.process.admin.formData.is_draft!='1'"
        >新增合同存档</span>
        <span
          class="title-age"
          v-if="showForm==='showFormHtSaveAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑合同存档</span>
        <span class="title-age" v-if="showForm==='showFormHtSaveHandle'">合同存档详情</span>
        <span
          class="title-age"
          v-if="showForm==='showFormExtrenalAdd'&& $store.state.process.admin.formData.is_draft!='1'"
        >新增外部用章</span>
        <span
          class="title-age"
          v-if="showForm==='showFormExtrenalAdd' && $store.state.process.admin.formData.is_draft=='1'"
        >编辑外部用章</span>
        <span class="title-age" v-if="showForm==='showFormExtrenalHandle'">外部用章详情</span>
        <span
          class="title-age"
          v-if="showForm==='showFormAnnounceAdd' && !$store.state.process.admin.formData.id"
        >新增公示存档</span>
        <span
          class="title-age"
          v-if="showForm==='showFormAnnounceAdd' && $store.state.process.admin.formData.id"
        >编辑公示存档</span>
        <span class="title-age" v-if="showForm==='showFormAnnounceHandle'">公示存档详情</span>
        <span
          class="title-age"
          v-if="showForm==='showFormNotifyAdd' && !$store.state.process.admin.formData.id"
        >新增告知书</span>
        <span
          class="title-age"
          v-if="showForm==='showFormNotifyAdd' && $store.state.process.admin.formData.id"
        >编辑告知书</span>
        <span class="title-age" v-if="showForm==='showFormNotifyHandle'">告知书详情</span>
      </div>
      <admin-details />
      <!-- <admin-details /> -->
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

import Draggable from 'vuedraggable'
import OneSelected from '../../components/OneSelected'
import AdminDetails from '../../components/finance/AdminDetails'

export default {
  data() {
    return {
      aboutList: [],
      formData: null,
      comReload: true,

      // 弹窗
      imgList: [],
      searchInfo1: '',
      searchDate1: '',
      searchDate2: '',
      searchIsArchive1: '',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      clientActive: '1',

      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.searchDate2) {
            return (
              time.getTime() > new Date(this.searchDate2).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.searchDate1) {
            return (
              time.getTime() <
                new Date(this.searchDate1).getTime() - 86400000 ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },

      // 新增邮寄
      addReimbursementForm: {
        remark: '',
        annex: [],
        project_id: [],
        business_name: '',
        address: '',
        receive: '',
      },
      // 新增报告用章审批
      addSettlementForm: {
        remark: '',
        annex: [],
        project_id: [],
        seal_type: '1',
        num: 1,
        business_name: '',
      },
      // 新增其他用章审批
      addExpertForm: {
        remark: '',
        annex: [],
        project_id: [],

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      },
      // 新增其他用章审批
      addHtForm: {
        remark: '',
        annex: [],
        project_id: [],

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      },
      // 新增报告用章审批
      addHtSaveForm: {
        remark: '',
        annex: [],
        project_id: [],
        business_name: '',
      },
      // 新增外部用章
      addExtrenalForm: {
        remark: '',
        annex: [],
        project_id: [],
        total: 0,

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      },
      selectProjectNum: '',
      approvalRemark: '',
      imgSize: '100%',
      detailsImgList: [],
      SearchPeopleId: '',
      tiemID: null,
      timeDou: 100,
    }
  },
  components: {
    Draggable,
    OneSelected,
    AdminDetails,
  },
  methods: {
    ...mapMutations('process/admin', [
      // 搜索相关
      'assignmentSearchDateSatrt',
      'assignmentSearchDateEnd',
      'assignmentSearch_member_id',
      'assignmentSearchInfo',
      'assignmentSearchIsArchive',
      // 页码相关
      'assignmentCurrentPage',
      'assignmentPageSize',
      'assignmentSearchType',
      // 财务/行政侧边栏展示哪种table
      'getContainerType',
      // 获取列表相关方法
      'getMailListMutations',
    ]),
    // 搜索栏信息改变存储到vuex
    searchData1Change(val) {
      this.assignmentSearchDateSatrt(val)
    },
    searchData2Change(val) {
      this.assignmentSearchDateEnd(val)
    },
    searchInputNameChange(val) {
      this.assignmentSearchInfo(val)
    },
    handleSearchIsArchiveChange(val) {
      this.assignmentSearchIsArchive(val || '0')
    },
    handleSearchPeopleChange(data) {
      this.assignmentSearch_member_id(data)
    },
    // 搜索栏信息改变存储到vuex

    // 导出
    // 点击导出(报销)
    handleOutClick(tourl, file_name) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.$store.state.process.admin.searchInfo)
      param.append(
        'search_member_id',
        this.$store.state.process.admin.search_member_id
      )
      if (tourl === '/api/Doc/contract_seal_output') {
        param.append(
          'is_archive',
          this.$store.state.process.admin.searchIsArchive || '0'
        )
      }
      this.$axios({
        method: 'post',
        url: tourl,
        data: param,
        // responseType: 'arraybuffer',
        // responseType: 'blob',
      }).then((res) => {
        console.log(res.data)
        if (res.data.code != 200) return this.$message.error(res.data.datas.msg)

        const fileName =
          file_name + this.parseTime(new Date(), '{y}{mm}{dd}') + '.xls'

        let link = document.createElement('a') //创建a标签
        link.style.display = 'none' //使其隐藏
        link.href = res.data.datas.file_url //赋予文件下载地址
        link.setAttribute('download', fileName) //设置下载属性 以及文件名
        document.body.appendChild(link) //a标签插至页面中
        link.click() //强制触发a标签事件
      })
    },

    handleSearch1() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getMailList()
    },
    handleSearch2() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getReportList()
    },
    handleSearch3() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getChapterList()
    },
    handleSearch4() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getHtList()
    },
    handleSearch5() {
      // if (this.searchDate1 == null || this.searchDate1 == 'null') {
      //   this.searchDate1 = ''
      // this.assignmentSearchDateSatrt('')
      // }
      // if (this.searchDate2 == null || this.searchDate2 == 'null') {
      //   this.searchDate2 = ''
      // this.assignmentSearchDateEnd('')
      // }
      this.assignmentCurrentPage(1)
      this.getHtSaveList()
    },
    handleSearch6() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.getExtrenalList(1)
      // this.getHtList()
    },
    handleSearch7() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getAnnounceList()
    },
    handleSearch8() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
        this.assignmentSearchDateSatrt('')
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
        this.assignmentSearchDateEnd('')
      }
      this.assignmentCurrentPage(1)
      this.getNotifyList()
    },
    // *查看外部用章审批详情
    async handleCheckExtrenal(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/external_seal_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }
      if (this.formData.total) {
        this.formData.total = parseInt(this.formData.total)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('external_seal')
        this.$store.commit('process/admin/getShowForm', 'showFormExtrenalAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('external_seal')
        this.$store.commit(
          'process/admin/getShowForm',
          'showFormExtrenalHandle'
        )
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      console.log('conloahusdhaisudhasuid', this.formData)
      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *外部用章批删除
    async handleRemoveExtrenal(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/external_seal_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getExtrenalList()
      }
    },
    // *6外部用章列表
    async getExtrenalList() {
      this.$store.commit('process/admin/getExtrenalList')
    },
    // *7查看公示存档详情
    async handleCheckAnnounce(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/announce_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(单选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 公示存档无审批
      // 草稿状态（is_draft='1'）允许继续编辑；已通过的项只读
      if (this.formData.is_draft == '1') {
        this.$store.commit('process/admin/getShowForm', 'showFormAnnounceAdd')
        this.$store.commit('process/admin/getDraftDisable', false)
      } else {
        this.$store.commit('process/admin/getShowForm', 'showFormAnnounceHandle')
      }
      this.$store.commit('process/admin/getFormData', this.formData)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // *7公示存档删除
    async handleRemoveAnnounce(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      if (isDelete === 'confirm') {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/announce_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getAnnounceList()
      }
    },
    // *7公示存档列表
    async getAnnounceList() {
      this.$store.commit('process/admin/getAnnounceList')
    },

    // *8查看告知书详情
    async handleCheckNotify(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/notify_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目（单选）
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 告知书无审批：草稿可继续编辑，已通过只读
      if (this.formData.is_draft == '1') {
        this.$store.commit('process/admin/getShowForm', 'showFormNotifyAdd')
        this.$store.commit('process/admin/getDraftDisable', false)
      } else {
        this.$store.commit('process/admin/getShowForm', 'showFormNotifyHandle')
      }
      this.$store.commit('process/admin/getFormData', this.formData)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // *8告知书删除
    async handleRemoveNotify(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      if (isDelete === 'confirm') {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/notify_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getNotifyList()
      }
    },
    // *8告知书列表
    async getNotifyList() {
      this.$store.commit('process/admin/getNotifyList')
    },

    // *查看合同存档详情
    async handleCheckHtSave(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/contract_archive_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理图片
      if (this.formData.annex) {
        this.imgList = this.formData.annex
        this.detailsImgList = this.formData.annex
      }

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      console.log('其他用章审批详情', this.formData)
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract_archive')
        this.$store.commit('process/admin/getShowForm', 'showFormHtSaveAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract_archive')
        this.$store.commit('process/admin/getShowForm', 'showFormHtSaveHandle')
      }
      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }

      this.$store.commit('process/admin/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *合同存档批删除
    async handleRemoveHtSave(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/contract_archive_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getHtSaveList()
      }
    },
    // *合同存档列表
    async getHtSaveList() {
      this.$store.commit('process/admin/getHtSaveList')
    },

    // *查看合同用章详情
    async handleCheckHt(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/contract_seal_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract_seal')
        this.$store.commit('process/admin/getShowForm', 'showFormHtAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('contract_seal')
        this.$store.commit('process/admin/getShowForm', 'showFormHtHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *合同用章批删除
    async handleRemoveHt(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/contract_seal_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getHtList()
      }
    },
    // *合同用章列表
    async getHtList() {
      this.$store.commit('process/admin/getHtList')
    },

    // *查看其他用章审批详情
    async handleCheckChapter(id) {
     console.log('查看其他用章审批详情')
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/chapter_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('chapter')
        this.$store.commit('process/admin/getShowForm', 'showFormZhuanAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('chapter')
        this.$store.commit('process/admin/getShowForm', 'showFormZhuanHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      console.log('conloahusdhaisudhasuid', this.formData)
      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *其他用章审批删除
    async handleRemoveExpert(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/chapter_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getChapterList()
      }
    },
    // *获取其他用章审批列表
    async getChapterList() {
      this.$store.commit('process/admin/getChapterList')
    },

    // *查看报告用章审批详情
    async handleCheckReport(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/report_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      console.log('报告用章审批详情', this.formData)

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('report')
        this.$store.commit('process/admin/getShowForm', 'showFormClearAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('report')
        this.$store.commit('process/admin/getShowForm', 'showFormClearHandle')
      }
      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *报告用章审批删除
    async handleRemoveSettlement(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/report_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getReportList()
      }
    },
    // *获取报告用章审批列表
    async getReportList() {
      this.$store.commit('process/admin/getReportList')
    },

    // *1查看邮寄详情
    async handleCheckMail(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/mail_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理图片
      if (this.formData.annex) {
        this.imgList = this.formData.annex
        this.detailsImgList = this.formData.annex
      }
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      console.log('邮寄详情', this.formData)
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('mail')
        this.$store.commit('process/admin/getShowForm', 'showFormAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('mail')
        this.$store.commit('process/admin/getShowForm', 'showFormHandle')
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *邮寄删除
    async handleRemoveMail(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/mail_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getMailList()
      }
    },
    // *获取邮寄列表
    async getMailList() {
      this.$store.commit('process/admin/getMailList')
    },

    // *获取项目列表
    async getProjectList() {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$store.commit('process/admin/assignmentProject', res.datas.listInfo)
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/admin/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/admin/setprojectListSub',
          res.datas.listInfo
        )
      }
    },
    // *获取项目列表(异步)
    getProjectListAsync(addClick, getList) {
      // console.log(getList)
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      }).then((res1) => {
        if (res1.data.code != 200) {
          getList()
          return this.$message.error(res1.data.datas.msg)
        }
        this.$store.commit(
          'process/admin/assignmentProject',
          res1.data.datas.listInfo
        )

        if (res1.data.datas.listInfo.length > this.moreNum) {
          this.$store.commit(
            'process/admin/setprojectListSub',
            res1.data.datas.listInfo.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/admin/setprojectListSub',
            res1.data.datas.listInfo
          )
        }
        getList()
        setTimeout(() => {
          console.log(addClick)
          addClick()
        })
      })
    },

    // ***获取预设审批人
    async get_preset_by_stage_code(stage_code) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/get_preset_by_stage_code',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$store.commit('process/admin/setList3', res.datas.list)
    },
    // 6新增外部用章
    addProjectExtrenalClick() {
      const data = {
        preset_member: '',

        remark: '',
        annex: [],
        project_id: [],
        total: 0,

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('external_seal')
      this.$store.commit('process/admin/getShowForm', 'showFormExtrenalAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 7新增公示存档
    addProjectAnnounceClick() {
      const data = {
        remark: '',
        annex: '',
        website_screenshot: '',
        provincial_screenshot: '',
        project_id: [],
        announce_name: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      this.$store.commit('process/admin/getShowForm', 'showFormAnnounceAdd')
      this.$store.commit('process/admin/getDraftDisable', false)
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 8新增告知书
    addProjectNotifyClick() {
      const data = {
        remark: '',
        annex: '',
        project_id: [],
        notify_name: '',
        notifier: '',
        notified_person: '',
        notified_unit: '',
        notify_time: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      this.$store.commit('process/admin/getShowForm', 'showFormNotifyAdd')
      this.$store.commit('process/admin/getDraftDisable', false)
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 5新增合同存档
    addProjectHtSaveClick() {
      const data = {
        preset_member: '',

        remark: '',
        annex: [],
        project_id: [],
        business_name: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('contract_archive')
      this.$store.commit('process/admin/getShowForm', 'showFormHtSaveAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 4新增合同用章
    addProjectHtClick() {
      const data = {
        preset_member: '',

        remark: '',
        annex: [],
        project_id: [],

        seal_type: '3',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人-

      this.get_preset_by_stage_code('contract_seal')
      this.$store.commit('process/admin/getShowForm', 'showFormHtAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 3新增其他用章审批
    addProjectZhuanClick() {
      const data = {
        preset_member: '',

        remark: '',
        annex: [],
        project_id: [],

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('chapter')
      this.$store.commit('process/admin/getShowForm', 'showFormZhuanAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 2新增报告用章审批
    addProjectClearClick() {
      const data = {
        preset_member: '',

        remark: '',
        annex: [],
        project_id: [],
        seal_type: '1',
        num: 1,
        business_name: '',
      }

      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('report')
      this.$store.commit('process/admin/getShowForm', 'showFormClearAdd')
      this.$store.commit('process/admin/getFormData', data)

      this.$store.commit('process/admin/getDialogVisible', true)
    },
    // 1新增邮寄
    addMailClick() {
      const data = {
        preset_member: '',

        remark: '',
        annex: [],
        project_id: [],
        business_name: '',
        address: '',
        receive: '',
      }
      if (this.$route.query.isFromProjectDrawer == '1') {
        data.project_id = [this.$route.query.project_id]
      }
      // 获取预设审批人
      this.get_preset_by_stage_code('mail')
      this.$store.commit('process/admin/getShowForm', 'showFormAdd')
      this.$store.commit('process/admin/getFormData', data)
      this.$store.commit('process/admin/getDialogVisible', true)
    },

    handleClick(tab, event) {
      if (
        this.$route.query.isFromProjectDrawer == '1' ||
        this.$route.query.isFromProjectDrawer == '2'
      ) {
        this.$router.push({ query: {} })
      }
      this.searchInfo1 = ''
      this.assignmentSearchInfo('')
      this.searchDate1 = ''
      this.assignmentSearchDateSatrt('')
      this.assignmentSearchDateSatrt('')
      this.searchDate2 = ''
      this.assignmentSearchDateEnd('')
      this.assignmentSearchDateEnd('')
      this.searchIsArchive1 = ''
      this.assignmentSearchIsArchive('0')
      this.SearchPeopleId = ''
      this.assignmentSearch_member_id('')

      this.assignmentPageSize(10)
      this.assignmentCurrentPage(1)
      console.log(tab, event)
      if (tab.name == '1') {
        this.getMailList()
      } else if (tab.name == '2') {
        this.getReportList()
      } else if (tab.name == '3') {
        this.getChapterList()
      } else if (tab.name == '4') {
        this.getHtList()
      } else if (tab.name == '5') {
        this.getHtSaveList()
      } else if (tab.name == '6') {
        this.getExtrenalList()
      } else if (tab.name == '7') {
        this.getAnnounceList()
      } else if (tab.name == '8') {
        this.getNotifyList()
      }
    },
    handleClose(done) {
      this.$store.commit('process/admin/getDialogVisible', false)
    },
    handleClosed() {
     console.log('关闭窗口')
      // 清空项目传来的id
      this.$route.query.isFromProjectDrawer = 2
      // 清空预设审批人
      this.$store.commit('process/admin/setList3', [])

      this.$store.commit('process/admin/emptyFormData')
      this.$store.commit('process/admin/getDraftDisable', false)
      this.$store.commit('process/admin/getSideBarShow', false)
      this.getContainerType('0')
      this.comReload = false
      setTimeout(() => {
        this.comReload = true
      }, 1)
    },

    handleSizeChange(val) {
      this.assignmentPageSize(val)
      if (this.clientActive == 1) {
        this.getMailList()
      }
      if (this.clientActive == 2) {
        this.getReportList()
      }
      if (this.clientActive == 3) {
        this.getChapterList()
      }
      if (this.clientActive == 4) {
        this.getHtList()
      }
      if (this.clientActive == 5) {
        this.getHtSaveList()
      }
      if (this.clientActive == 6) {
        this.getExtrenalList()
      }
      if (this.clientActive == 7) {
        this.getAnnounceList()
      }
      if (this.clientActive == 8) {
        this.getNotifyList()
      }
    },
    handleCurrentChange(val) {
      this.assignmentCurrentPage(val)
      if (this.clientActive == 1) {
        this.getMailList()
      }
      if (this.clientActive == 2) {
        this.getReportList()
      }
      if (this.clientActive == 3) {
        this.getChapterList()
      }
      if (this.clientActive == 4) {
        this.getHtList()
      }
      if (this.clientActive == 5) {
        this.getHtSaveList()
      }
      if (this.clientActive == 6) {
        this.getExtrenalList()
      }
      if (this.clientActive == 7) {
        this.getAnnounceList()
      }
      if (this.clientActive == 8) {
        this.getNotifyList()
      }
    },
    // 解析时间
    parseTime(time, fm) {
      // 解析时间  time: 时间戳或者实践对象 fm: 格式 默认是{y}-{m}-{d} {h}:{i}:{s}
      if (arguments.length === 0) {
        return null
      }
      const format = fm || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a')
          return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    },
  },
  computed: {
    ...mapState('process/admin', [
      'list',
      // 搜索相关
      'searchDateSatrt',
      'searchDateEnd',
      'search_member_id',
      'searchInfo',
      'searchIsArchive',
      // 页码相关
      'currentPage',
      'pageSize',
      'Total',
      // 详情弹窗可见
      'dialogVisible',
      // 判断是否是管理员(是否可删除)
      'isAdmin1',
      'isAdmin2',
      'isAdmin3',
      'isAdmin4',
      'isAdmin5',
      'isAdmin6',
      'isAdmin7',
      'isAdmin8',
      'showForm',
      'moreNum',
    ]),
  },
  watch: {
    clientActive(val, oldVal) {
      //普通的watch监听
      switch (val) {
        case '2':
        case '3':
        case '4':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break
        case '5':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break
        case '6':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break
        case '7':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break
        case '8':
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '50px'
          })
          break
        default:
          this.$nextTick(() => {
            let a = document.getElementsByClassName('el-tabs__active-bar')
            a[0].style.marginLeft = '30px'
          })
          break
      }
    },
  },
  activated() {
    // !项目带id跳转别的
    if (this.$route.query.isFromProjectDrawer == '1') {
      switch (this.$route.query.fromDrawType) {
        case '邮寄':
          this.clientActive = '1'
          this.getProjectListAsync(this.addMailClick, this.getMailList)
          break
        case '报告用章':
          this.clientActive = '2'
          this.getProjectListAsync(
            this.addProjectClearClick,
            this.getReportList
          )
          break
        case '其他用章':
          this.clientActive = '3'
          this.getProjectListAsync(
            this.addProjectZhuanClick,
            this.getChapterList
          )
          break
        case '合同用章':
          this.clientActive = '4'
          this.getProjectListAsync(this.addProjectHtClick, this.getHtList)
          break
        case '合同存档':
          this.clientActive = '5'
          this.getProjectListAsync(
            this.addProjectHtSaveClick,
            this.getHtSaveList
          )
          break
        case '外部用章':
          this.clientActive = '6'
          this.getProjectListAsync(
            this.addProjectExtrenalClick,
            this.getExtrenalList
          )
          break
        default:
          break
      }
    }
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.activeName = this.$route.query.type
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.assignmentSearchIsArchive('0')
    this.getProjectList()
    this.getMailList()
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
@import url(./finance.scss);
/deep/#MyTransfer {
  .filter-dash-btn {
    width: 100%;
    .filter-tips-default {
      width: 100%;
      padding-left: 25px;
    }
  }
}
.contractSearchRow {
  display: grid !important;
  grid-template-columns: minmax(180px, 1.5fr) minmax(140px, 1fr) 24px minmax(
      140px,
      1fr
    ) minmax(160px, 1fr) 140px;
  column-gap: 12px;
  align-items: center;

  > span {
    margin: 0 !important;
    text-align: center;
  }
}

/deep/.contractSearchRow > .el-input,
/deep/.contractSearchRow > .el-date-editor,
/deep/.contractSearchRow > #MyTransfer,
/deep/.contractSearchRow > .archiveSelect {
  width: 100% !important;
  min-width: 0;
  margin-right: 0 !important;
}

/deep/.contractSearchRow > .archiveSelect .el-input {
  width: 100% !important;
  margin-right: 0 !important;
}
</style>
